import { NgModule } from '@angular/core';

import { InstallationsMigrationModule } from '../+installations/installations/installation-migration/migrate-installations.module';
import { SharedDependenciesModule } from '../shared/index';

import { TranslateSearchListTypePipe } from '../operational-data-common/translation-pipes/translate-search-list-type.pipe';
import { ViDswFooterComponent } from '../shared/+design-system-web/vi-dsw-footer/vi-dsw-footer.component';
import { SearchRouting } from './search.routing';
import { SearchService } from './search.service';
import { ErrorSearchComponent } from './search/search-fields/error-search/error-search.component';
import { GatewaySearchComponent } from './search/search-fields/gateway-search/gateway-search.component';
import { SearchFieldsComponent } from './search/search-fields/search-fields.component';
import { UserSearchComponent } from './search/search-fields/user-search/user-search.component';
import { VouchersModule } from './search/search-fields/vouchers/vouchers.module';
import { SearchHistoryComponent } from './search/search-history/search-history.component';
import { SearchParamsAsTextPipe } from './search/search-history/search-params-as-text.pipe';
import { SearchComponent } from './search/search.component';
import { AddressDetailsComponent } from './user-details/change-user-details-modal/address-details/address-details.component';
import { ChangeUserDetailsModalComponent } from './user-details/change-user-details-modal/change-user-details-modal.component';
import { ContactDetailsComponent } from './user-details/change-user-details-modal/contact-details/contact-details.component';
import { OtherDetailsComponent } from './user-details/change-user-details-modal/other-details/other-details.component';
import { PersonalDetailsComponent } from './user-details/change-user-details-modal/personal-details/personal-details.component';
import { FlatRateBookingsComponent } from './user-details/user-booking-list/flat-rate-bookings/flat-rate-bookings.component';
import { FlatRateRowComponent } from './user-details/user-booking-list/flat-rate-row/flat-rate-row.component';
import { PackagePerInstallationBookingsComponent } from './user-details/user-booking-list/package-per-installation-bookings/package-per-installation-bookings.component';
import { PackagePerInstallationRowComponent } from './user-details/user-booking-list/package-per-installation-row/package-per-installation-row.component';
import { SortBookingsPipe } from './user-details/user-booking-list/sort-bookings.pipe';
import { UserBookingListComponent } from './user-details/user-booking-list/user-booking-list.component';
import { GatewayInvitationListComponent } from './user-details/user-gateway-list/gateway-invitation-list/gateway-invitation-list.component';
import { UserGatewayListComponent } from './user-details/user-gateway-list/user-gateway-list.component';
import { SalutationPipe } from '../shared/pipes/salutation/salutation.pipe';

@NgModule({
  imports: [
    SharedDependenciesModule,
    SearchRouting,
    VouchersModule,
    InstallationsMigrationModule,
    UserGatewayListComponent,
    UserBookingListComponent,
    FlatRateBookingsComponent,
    PackagePerInstallationBookingsComponent,
    SortBookingsPipe,
    PackagePerInstallationRowComponent,
    FlatRateRowComponent,
    ViDswFooterComponent,
    SalutationPipe,
  ],
  declarations: [
    SearchComponent,
    SearchFieldsComponent,
    SearchHistoryComponent,
    UserSearchComponent,
    ErrorSearchComponent,
    GatewaySearchComponent,
    SearchParamsAsTextPipe,
    TranslateSearchListTypePipe,
    ChangeUserDetailsModalComponent,
    PersonalDetailsComponent,
    AddressDetailsComponent,
    ContactDetailsComponent,
    OtherDetailsComponent,
    GatewayInvitationListComponent,
  ],
  providers: [SearchService],
})
export class SearchModule {}
